import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="checkboxes"
export default class extends Controller {
  static targets = [ "label", "checkbox" ]

  connect() {

    this.labelTargets.forEach((label) => {
      if (label.checked) {
        label.nextElementSibling.style.backgroundColor = 'rgb(238, 241, 251)'
      }
    })

    this.labelTargets.forEach((label) => {
      label.addEventListener('click', (event) => {
        if (event.target.nextElementSibling.style.backgroundColor == 'rgb(238, 241, 251)') {
          label.nextElementSibling.style.backgroundColor = 'white'
        } else {
          label.nextElementSibling.style.backgroundColor = 'rgb(238, 241, 251)'
        }
      })
    })
  }
}
